module.exports = __webpack_public_path__ + "img/metal.ore.175da11e.png";